export enum NotificationType {
    success,
    error,
    warning,
    information
}

export type NotificationTypeUnion = 'success' | 'error' | 'warning' | 'information';

export type NotificationTypeKeys = keyof typeof NotificationType;
